import { Enumify } from "enumify-ts";
class WouldRecommendType extends Enumify() {
    description;
    static DEFINITELY = new WouldRecommendType('Definitely');
    static MAYBE = new WouldRecommendType('Maybe');
    static NOT_SURE = new WouldRecommendType('Not Sure');
    static PROBABLY_NOT = new WouldRecommendType('Probably Not');
    static NO_CHANCE = new WouldRecommendType('No Chance');
    static _ = WouldRecommendType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
}
export default WouldRecommendType;
